import {Injectable} from '@angular/core';
import {Subscription, Subject} from 'rxjs';

class EventModel {
    topic: string;
    subject = new Subject<any>();

    constructor(topic) {
        this.topic = topic;
    }
}

@Injectable({ providedIn: 'root' })
export class EventsService {
    private events: EventModel[] = [];

    protected getEvent(topic: string): Subject<any> {
        let event = this.events.find(item => item.topic === topic);
        if (!event) {
            event = new EventModel(topic);
            this.events.push(event);
        }
        return event.subject;
    }

    publish(topic: string, arg: any = null) {
        this.getEvent(topic).next(arg);
    }

    subscribe(topic: string, handler): Subscription {
        return this.getEvent(topic).asObservable().subscribe(handler);
    }
}
